(function() {
	"use strict";

	angular
		.module("qbePortal")
		.service("embargoTestService", embargoTestService);

	embargoTestService.$inject = ["$state"];

	function embargoTestService($state) {
		this.testEmbargoDecline = testEmbargoDecline;

		function testEmbargoDecline(response) {
			var data = response.data || response.quote;

			if (data.quoteResult) {
				var declineParams = {
					declineType: "",
					declineCodes: []
				};

				if (data.quoteResult.embargo) {
					declineParams.declineType = "embargo";
				} else if (
					data.quoteResult.referral &&
					!data.quoteResult.embargo
				) {
					declineParams.declineType = "referral";
				} else if (
					data.quoteResult.decline &&
					!data.quoteResult.embargo
				) {
					declineParams.declineType = "decline";
				}

				data.quoteResult.uwIssues.forEach(function(element) {
					declineParams.declineCodes.push(element.typeCode);
				}, this);

				return declineParams;
			}
			return null;
		}
	}
})();
